import React from 'react';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '../../store/userInfoStore';
import useTranslation from '../../hooks/useTranslation';
import { cryptoCurrencies } from '../../core/constants/cryptoCurrencies';
// import { iframeService } from '../../services/iframeService';
import { isPG } from '../../core/helpers/skinHelper';
import './BalanceRow.scss';
import { isMobile } from '../../core/helpers/isMobile';
import GameLogo from '../gameLogo';

const UserBalance = observer(({ gameName }) => {
  const { userBalance, currencyCode, currencyCodeAbbr } = userInfoStore;
  const t = useTranslation();

  return (
    <div className='cpt-balance-row'>
      <div className='cpt-balance-row-content'>
        {/* /!* ToDo add class game name *!/ */}
        {/* <div className='cpt-game-name-gameLogo limbo' /> */}
        {/* <p className='cpt-game-name'>{t(gameName)}</p> */}
        <div className='cpt-balance-col'>
          {isPG() && isMobile() ? (
            <GameLogo gameName={gameName} />
          ) : //   isPG() ? (
          //   <div onClick={() => iframeService.redirectHome()} className='cpt-home-page'>
          //     <i className='icon-home' />
          //   </div>
          // ) :
          null}
          <div className='cpt-balance-info'>
            <span className='cpt-balance-text'>{t('BALANCE')} :</span>
            <div className='cpt-amount-column'>
              <span
                className={`cpt-dollar-img ${isPG() ? '' : cryptoCurrencies[currencyCodeAbbr]}`}
                data-cur={currencyCode}
              />
              <span className='cpt-balance-amount'>{userBalance}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
export default UserBalance;
